var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTagEdit48Line = function SvgIconTagEdit48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 25.699a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4ZM40.79 12.379l-2.29-2.28c-.47-.47-1.23-.47-1.7 0l-9.11 9.11-.8 4.08c-.08.42.29.79.7.7l4.08-.8 9.11-9.11c.47-.47.47-1.23 0-1.7h.01Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9 30.399a1.9 1.9 0 0 1-1.9 1.9H18.47c-.62 0-1.2-.3-1.56-.81l-4.48-6.4c-.46-.65-.46-1.53 0-2.18l4.48-6.4c.36-.51.94-.81 1.56-.81h7.84v-3.4h-7.84c-1.73 0-3.35.85-4.34 2.26l-4.48 6.4a5.327 5.327 0 0 0 0 6.08l4.48 6.4a5.285 5.285 0 0 0 4.34 2.26H34c2.92 0 5.3-2.38 5.3-5.3v-7.8h-3.4v7.8Z",
    fill: "current"
  })));
};
export default SvgIconTagEdit48Line;